export { default } from "./CategoryMenuStrapi.jsx";
